<template>
  <div>
    <Layout v-if="formHome">
      <div class="container-app">
        <div class="card-app">
          <div class="row">
            <formFillHome
              :formBodyHome="changeFormBodyHome"
              :families="families"
              :familiHome="familiHome"
              :infoCodHogar="infoCodHogar"
              :handleInfoHome="handleInfoHome"
            />
            <div
              v-if="formBody && infoCodHome && Object.keys(formData).length > 0"
              class="col-lg-12 col-md-12 p-0 mr-0 ml-0"
            >
              <b-overlay
                :show="isSaving"
                blur="5px"
                :opacity="1"
                variant="transparent"
                spinner-variant="primary"
                spinner-type="grow"
                rounded="sm"
              >
                <ValidationObserver id="typeForm" ref="observer">
                  <b-tabs
                    v-model="tabIndex"
                    ref="tabs"
                    small
                    card
                    @activate-tab="tabActivated"
                    class="tabs-forms"
                  >
                    <ValidationObserver ref="obs0" v-slot="{ handleSubmit }">
                      <b-tab id="obs0" title="Base" class="base-vars p-2">
                        <b-card
                          v-for="(dimension, key) in formData.dimensions"
                          :key="`dim-${dimension.id}-${key}-base`"
                          no-body
                          class="section-card"
                          v-show="
                            Object.keys(dimension.base_variables).length > 0
                          "
                        >
                          <b-card-header class="pl-2 bg-transparent">
                            <h6 class="text-primary"
                              >{{ dimension.name }}
                              <small class="text-muted d-none">{{
                                dimension.description
                              }}</small></h6
                            >
                          </b-card-header>
                          <b-card-body class="p-0 pb-1">
                            <div class="row">
                              <div
                                class="col-md-6"
                                v-for="(variable,
                                index) in dimension.base_variables"
                                :key="
                                  `dim-${dimension.id}-base-${index}-${
                                    variable.idk
                                  }`
                                "
                              >
                                <renderVariable
                                  :variable="variable"
                                  :key="`${renderTimestamp + index}`"
                                  :isComponent="false"
                                  :isPreview="false"
                                  :validateDependents="validateDependents"
                                  :isFormFill="true"
                                  :familiHome="familiHome"
                                  :findDataAutocomplete="findDataAutocomplete"
                                  :autoCompleteInputDisable="
                                    autoCompleteInputDisable
                                  "
                                />
                              </div>
                            </div>
                          </b-card-body>
                        </b-card>
                        <div class="row">
                          <div class="col-md-12">
                            <b-button
                              v-if="
                                tabIndex !== 1 && !autoCompleteInputDisable
                              "
                              class="float-right"
                              variant="primary"
                              pill
                              @click="handleSubmit(saveForm)"
                              >Siguiente</b-button
                            >
                          </div>
                        </div>
                      </b-tab>
                    </ValidationObserver>
                    <ValidationObserver ref="obs1" v-slot="{ handleSubmit }">
                      <b-tab
                        id="obs1"
                        title="Extendidas"
                        class="extended-vars p-2"
                        @click="
                          () => {
                            return false
                          }
                        "
                      >
                        <b-card
                          v-for="(dimension, key) in formData.dimensions"
                          :key="`dim-${dimension.id}-${key}-extended`"
                          no-body
                          class="section-card"
                          v-show="
                            Object.keys(
                              dimension.extended_variables.filter(
                                (y) => y.display === true
                              ) || {}
                            ).length > 0
                          "
                        >
                          <b-card-header class="pl-2 bg-transparent">
                            <h6 class="text-primary"
                              >{{ dimension.name }}
                              <small class="text-muted d-none">{{
                                dimension.description
                              }}</small></h6
                            >
                          </b-card-header>
                          <b-card-body class="p-0 pb-1">
                            <div class="row">
                              <div
                                v-for="(variable,
                                index2) in dimension.extended_variables"
                                :key="
                                  `prev-dim-${dimension.id}-var-${index2}-${
                                    variable.idk
                                  }-${variable.display}-${renderTimestamp}`
                                "
                                class="col-md-6"
                                :class="{ 'd-none': !variable.display }"
                              >
                                <renderVariable
                                  v-if="variable.display"
                                  :key="`${renderTimestamp + index2}`"
                                  :data-display="
                                    `${variable.variable}-${
                                      variable.display
                                    }-${renderTimestamp}`
                                  "
                                  :variable="variable"
                                  :isComponent="false"
                                  :isPreview="false"
                                  :validateDependents="validateDependents"
                                  :autoCompleteInputDisable="
                                    autoCompleteInputDisable
                                  "
                                />
                              </div>
                            </div>
                          </b-card-body>
                        </b-card>
                        <div class="row">
                          <div class="col-md-12">
                            <!-- {{ formData['dimensions'][1] }} -->
                            <b-button
                              v-if="tabIndex > 0"
                              variant="outline-primary"
                              pill
                              @click="tabIndex--"
                              >Ir Atrás</b-button
                            >
                            <b-button
                              v-if="tabIndex === 1"
                              class="float-right"
                              variant="primary"
                              pill
                              @click="
                                !Object(formData).hasOwnProperty('id')
                                  ? () => {}
                                  : handleSubmit(saveForm)
                              "
                              v-b-tooltip.hover="{
                                variant: !Object(formData).hasOwnProperty(
                                  'id'
                                )
                                  ? 'danger'
                                  : 'info',
                                title: !Object(formData).hasOwnProperty('id')
                                  ? 'No ha guardado el formulario en el paso anterior'
                                  : 'Guardar variables extendidas',
                              }"
                              >Guardar</b-button
                            >
                          </div>
                        </div>
                      </b-tab>
                    </ValidationObserver>
                  </b-tabs>
                </ValidationObserver>
              </b-overlay>
            </div>
          </div>
        </div>
      </div>
    </Layout>
    <Layout v-else>
      <PageHeader
        :items="items"
      />
      <div class="container-app">
        <div class="content-title">
          <span class="title-card-app">{{ form.title }}</span>
          <span>
            <router-link
              size="sm"
              class="p-0 ml-2 btn-link-add"
              :to="{ name: 'formFillList' }"
            >
              <b-icon
                class="icon-plus"
                icon="arrow90deg-left"
              ></b-icon>
            </router-link>
          </span>
        </div>
        <div class="card-app">
          <div class="row">
            <div
              class="col-lg-12 col-md-12 p-0 mr-0 ml-0"
              v-if="Object.keys(formData).length > 0"
            >
              <b-overlay
                :show="isSaving"
                blur="5px"
                :opacity="1"
                variant="transparent"
                spinner-variant="primary"
                spinner-type="grow"
                rounded="sm"
              >
                <ValidationObserver id="typeForm" ref="observer">
                  <b-tabs
                    v-model="tabIndex"
                    ref="tabs"
                    small
                    card
                    @activate-tab="tabActivated"
                    class="tabs-forms"
                  >
                    <ValidationObserver ref="obs0" v-slot="{ handleSubmit }">
                      <b-tab id="obs0" title="Base" class="base-vars p-2">
                        <b-card
                          v-for="(dimension, key) in formData.dimensions"
                          :key="`dim-${dimension.id}-${key}-base`"
                          no-body
                          class="section-card"
                          v-show="
                            Object.keys(dimension.base_variables).length > 0
                          "
                        >
                          <b-card-header class="pl-2 bg-transparent">
                            <h6 class="text-primary"
                              >{{ dimension.name }}
                              <small class="text-muted d-none">{{
                                dimension.description
                              }}</small></h6
                            >
                          </b-card-header>
                          <b-card-body class="p-0 pb-1">
                            <div class="row">
                              <div
                                class="col-md-6"
                                v-for="(variable,
                                index) in dimension.base_variables"
                                :key="
                                  `dim-${dimension.id}-base-${index}-${
                                    variable.idk
                                  }`
                                "
                              >
                                <renderVariable
                                  :variable="variable"
                                  :isComponent="false"
                                  :isPreview="false"
                                  :validateDependents="validateDependents"
                                  :isFormFill="true"
                                  :findDataAutocomplete="findDataAutocomplete"
                                  :autoCompleteInputDisable="
                                    autoCompleteInputDisable
                                  "
                                />
                              </div>
                            </div>
                          </b-card-body>
                        </b-card>
                        <div class="row">
                          <div class="col-md-12">
                            <b-button
                              v-if="tabIndex !== 1 && !autoCompleteInputDisable"
                              class="float-right"
                              variant="primary"
                              pill
                              @click="handleSubmit(saveForm)"
                              >Siguiente</b-button
                            >
                          </div>
                        </div>
                      </b-tab>
                    </ValidationObserver>
                    <ValidationObserver ref="obs1" v-slot="{ handleSubmit }">
                      <b-tab
                        id="obs1"
                        title="Extendidas"
                        class="extended-vars p-2"
                        @click="
                          () => {
                            return false
                          }
                        "
                      >
                        <b-card
                          v-for="(dimension, key) in formData.dimensions"
                          :key="`dim-${dimension.id}-${key}-extended`"
                          no-body
                          class="section-card"
                          v-show="
                            Object.keys(
                              dimension.extended_variables.filter(
                                (y) => y.display === true
                              ) || {}
                            ).length > 0
                          "
                        >
                          <b-card-header class="pl-2 bg-transparent">
                            <h6 class="text-primary"
                              >{{ dimension.name }}
                              <small class="text-muted d-none">{{
                                dimension.description
                              }}</small></h6
                            >
                          </b-card-header>
                          <b-card-body class="p-0 pb-1">
                            <div class="row">
                              <div
                                v-for="(variable,
                                index2) in dimension.extended_variables"
                                :key="
                                  `prev-dim-${dimension.id}-var-${index2}-${
                                    variable.idk
                                  }-${variable.display}-${renderTimestamp}`
                                "
                                class="col-md-6"
                                :class="{ 'd-none': !variable.display }"
                              >
                                <renderVariable
                                  v-if="variable.display"
                                  :key="`${renderTimestamp}`"
                                  :data-display="
                                    `${variable.variable}-${
                                      variable.display
                                    }-${renderTimestamp}`
                                  "
                                  :variable="variable"
                                  :isComponent="false"
                                  :isPreview="false"
                                  :validateDependents="validateDependents"
                                  :autoCompleteInputDisable="
                                    autoCompleteInputDisable
                                  "
                                />
                              </div>
                            </div>
                          </b-card-body>
                        </b-card>
                        <div class="row">
                          <div class="col-md-12">
                            <!-- {{ formData['dimensions'][1] }} -->
                            <b-button
                              v-if="tabIndex > 0"
                              variant="outline-primary"
                              pill
                              @click="tabIndex--"
                              >Ir Atrás</b-button
                            >
                            <b-button
                              v-if="tabIndex === 1"
                              class="float-right"
                              variant="success"
                              pill
                              @click="
                                !Object(formData).hasOwnProperty('id')
                                  ? () => {}
                                  : handleSubmit(saveForm)
                              "
                              v-b-tooltip.hover="{
                                variant: !Object(formData).hasOwnProperty('id')
                                  ? 'danger'
                                  : 'info',
                                title: !Object(formData).hasOwnProperty('id')
                                  ? 'No ha guardado el formulario en el paso anterior'
                                  : 'Guardar variables extendidas',
                              }"
                              >Guardar</b-button
                            >
                          </div>
                        </div>
                      </b-tab>
                    </ValidationObserver>
                  </b-tabs>
                </ValidationObserver>
              </b-overlay>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  </div>
</template>
<script>
import Layout from '@layouts/main'
import { Drag, Drop, DropList } from 'vue-easy-dnd'
import PageHeader from '@components/page-header'
import { decrypt } from '@utils/local-storage'
import _ from 'lodash'

import { formMethods, variablesMethods, familiesMethods } from '@state/helpers'

import InputText from '@components/form/InputText'
import InputTextarea from '@components/form/InputTextarea'
import InputSelect from '@components/form/InputSelect'
import InputMultiSelect from '@components/form/InputMultiSelect'
import InputRadio from '@components/form/InputRadio'
import InputCheckbox from '@components/form/InputCheckbox'
import formFillHome from '@views/forms/formFillHome'
import { families } from '@views/forms/dataFamilies'

import RenderVariable from '@views/variables/renderVariable.vue'

export default {
  page: {
    title: 'Diligenciar Formulario',
  },
  components: {
    formFillHome,
    Layout,
    PageHeader,
    Drag,
    Drop,
    DropList,
    InputText,
    InputTextarea,
    InputRadio,
    InputSelect,
    InputMultiSelect,
    InputCheckbox,
    RenderVariable,
  },
  data() {
    let stateObj = [{ id: 'A', name: 'Activo' }, { id: 'I', name: 'Inactivo' }]

    return {
      infoCodHome: '',
      familiHome: {},
      families,
      formBody: false,
      formHome: false,
      autoCompleteInputDisable: true,
      isSaving: false,
      initFormSW: true,
      renderTimestamp: Date.now(),
      tabIndex: 0,
      lastTabError: null,
      title: 'Form',
      locale: 'es',
      formData: {},
      editMode: false,
      actionToClean: false,
      extendedVariableSearch: '',
      dimensions: {},
      form: {
        id: null,
        title: '',
        state: stateObj.filter((x) => x.id === 'A')[0],
      },
      extended_variables: [],
      base_variables: [],
      items: [
        {
          text: '/',
          path: '/home',
          to: { name: 'home' },
        },
        {
          text: 'Formularios',
          active: true,
        },
      ],
      lists: [],
      extraButtons: [
        {
          variant: 'success',
          title: 'Diligenciar Formularios',
          to: { name: 'formFillList' },
          icon: 'arrow90deg-left',
        },
      ],
    }
  },

  mounted() {
    this.initForm()
  },

  methods: {
    ...formMethods,
    ...variablesMethods,
    ...familiesMethods,
    getSavedState(key) {
      key =
        JSON.parse(this.getStateLocalStorage('auth.currentSession')).user
          .username +
        '.' +
        key
      let retorno = JSON.parse(this.getStateLocalStorage(key) || '[]')
      return retorno
    },
    getStateLocalStorage(key) {
      let storage = window.localStorage.getItem(key)
      if (storage != null) {
        if (typeof storage == Object && storage.length < 0) {
          return '[]'
        }
        return decrypt(storage)
      } else {
        return null
      }
    },
    handleInfoHome(value) {
      this.infoCodHome = value
    },
    changeFormBodyHome() {
      this.formBody = true
    },
    initForm() {
      this.initFormSW = true
      this.formData = {}
      this.form = {}
      this.tabIndex = 0
      this.dimensions = {}
      this.base_variables = []
      this.extended_variables = []
      let data = {}
      const forms_cached = this.getSavedState('forms_cached')
      if (forms_cached.results.length > 0) {
        data = forms_cached.results.filter(
          (x) => x.id === parseInt(this.$route.params.formId)
        )[0].form
        this.formHome = data.fillByHouseHold
      } else {
        this.getForms({
          query: '?no_managers=true&page_size=999',
          formId: this.$route.params.formId,
        }).then((result) => {
          data = result
        })
      }
      data = _.cloneDeep(data)
      const extended_variables = data.dimensions
        .map((x) => {
          return {
            id: x.id,
            name: x.name,
            order: x.order,
            dimension_id: x.dimension_id,
            form: x.form,
            items: x.extended_variables,
          }
        })
        .filter((y) => y.items.length > 0)
        .sort((a, b) => (a.order > b.order && 1) || -1)
      this.getDimensionsData(extended_variables)
      if (this.$route.params.sessionId) {
        this.getFormSession(this.$route.params.sessionId, { ...data }).then(
          (x) => {
            this.editMode = true
            this.form = { ...x }
          }
        )
      } else {
        this.form = { ...data }
      }
    },

    getDimensionsData(default_ext_variables = null) {
      let vm = this
      let data = {}
      const dimensions_cached = this.getSavedState('dimensions_cached')
      if (dimensions_cached.results.length > 0) {
        data = [...dimensions_cached.results]
      } else {
        this.getDimensions('?page_size=999').then((result) => {
          data = [...result.results]
        })
      }

      this.dimensions = data
      this.base_variables = data.map((x) => {
        return {
          id: x.id,
          name: x.name,
          order: x.order,
          items: x.base_variables,
        }
      })
      if (default_ext_variables) {
        let form_id = default_ext_variables[0].form
        this.extended_variables = default_ext_variables
        // remove from dimensions/extended_variables, the used in this form
        const flatted_ev = default_ext_variables
          .map((z) => {
            return z.items.map((z1) => {
              return z1.variable
            })
          })
          .flatMap((x) => x)
        this.dimensions.forEach((x) => {
          x.extended_variables.forEach((y) => {
            if (flatted_ev.includes(y.variable)) {
              x.extended_variables = x.extended_variables.filter(function(
                item
              ) {
                return item.variable !== y.variable
              })
            }
          })
        })
        // base variables as required:
        this.base_variables.forEach((x) => {
          x.items.forEach((y) => {
            Object.assign(y, { extra_config: { required: true } })
          })
        })
        // hide extended depends variables:
        this.extended_variables.forEach((x) => {
          x.items.forEach((y) => {
            if (!!y.extra_config.depends) {
              y.display = false
            } else {
              y.display = true
            }
          })
        })

        // building formData:
        const local_ext_var = [...this.extended_variables] // _.cloneDeep(this.extended_variables) //  JSON.parse(JSON.stringify(this.extended_variables))
        const local_dim = [...this.dimensions] // _.cloneDeep(this.dimensions) // JSON.parse(JSON.stringify(this.dimensions))
        this.formData = {
          form_manager: this.$route.params.formId,
          form: form_id,
          mode: 'record',
          dimensions: [],
          codigoFamilia: this.infoCodHome,
        }
        local_dim.forEach((dim, index) => {
          const act_dim_ = local_ext_var.filter(
            (ev) => ev.dimension_id === dim.dimension_id
          )[0]
          vm.formData.dimensions[index] = {
            id: dim.dimension_id,
            name: dim.name,
            description: dim.description,
            base_variables: dim.base_variables,
            extended_variables:
              act_dim_ !== undefined && act_dim_.hasOwnProperty('items')
                ? act_dim_.items
                : [],
          }
        })
      }
    },

    saveForm(action = null) {
      this.isSaving = true
      let _ = this
      const dataSend = { ...this.formData, codigoFamilia: this.infoCodHome }
      const promise = this.setFormSession(dataSend)

      return promise
        .then((data) => {
          _.isSaving = false
          if (data.hasOwnProperty('id')) {
            _.formData.id = data.id
            _.editMode = true
          }
          if (data.hasOwnProperty('key')) {
            _.formData.key = data.key
          }
          if (data.hasOwnProperty('start_time')) {
            _.formData.start_time = data.start_time
          }
          // const msg_queue =
          //   data.queue_sessions > 0
          //     ? `${data.queue_sessions} registros pendientes por sincronizar`
          //     : ''
          // // _.$generate_noty(
          // //   'success',
          // //   `Formulario ${_.editMode ? 'actualizado' : 'guardado'} ${
          // //     _.formData.id !== null ? 'remotamente' : 'localmente'
          // //   }.<br><b>${msg_queue}</b>`
          // // )
          if (_.tabIndex === 0) {
            _.$nextTick(() => {
              _.tabIndex++
              this.initFormSW = false
              this.isSaving = false
              // return
            })
          } else {
            _.$nextTick(() => {
              _.initForm()
              _.$generate_noty(
                'info',
                `El formulario se ha guardado exitosamente`
              )
            })
          }
        })
        .catch((error) => {
          _.isSaving = false
          _.$generate_noty('error', error)
          console.log('Se presento un error al guardar el formulario', error)
        })
    },

    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },

    async tabActivated(newTabIndex, prevTabIndex, bvEvent) {
      this.formData.codigoFamilia = this.infoCodHome
      if (this.initFormSW === true) {
        this.$refs['observer'].observers[0].reset()
        this.initFormSW = false
        return true
      }
      if (this.$refs['observer'].observers[prevTabIndex] !== undefined) {
        const valid = await this.$refs['observer'].observers[
          prevTabIndex
        ].validate()
        if (!valid && this.lastTabError === null) {
          this.lastTabError = prevTabIndex
          bvEvent.preventDefault()
          this.$generate_noty(
            'error',
            `Hay errores en el formulario ${
              this.$refs['tabs'].registeredTabs[prevTabIndex].title
            }, verifique`
          )
          await this.sleep(400)
          this.tabIndex = 0
        } else {
          this.lastTabError = null
          this.tabIndex = newTabIndex
        }
      }
    },

    getVariableInfoById(id) {
      let variable = []
      this.dimensions.forEach((element) => {
        element.base_variables.forEach((element2) => {
          if (element2.variable === parseInt(id)) {
            variable = element2
          }
        })
      })
      this.extended_variables.forEach((element) => {
        element.items.forEach((element2) => {
          if (element2.variable === parseInt(id)) {
            variable = element2
          }
        })
      })
      return variable
    },

    getVariableDependents(id) {
      let dependents = []
      this.extended_variables.forEach((element) => {
        element.items.forEach((element2) => {
          if (element2.extra_config.depends === parseInt(id)) {
            dependents.push(element2.variable)
          }
        })
      })
      return dependents
    },

    validateDependents(variable) {
      const dependents =
        variable.extra_config.dependents ||
        this.getVariableDependents(variable.variable)
      this.$nextTick(() => {
        dependents.forEach((x) => {
          let var_ = this.getVariableInfoById(x)
          if (Object.keys(variable.value).length > 0) {
            const cond = var_.extra_config.depends_condition
            const dep_val = var_.extra_config.depends_value
            if (
              cond === 'IN' &&
              (variable.value === dep_val || variable.value.key
                ? Object.values(dep_val).filter(
                    (x) => x.trim() === variable.value.key.trim()
                  ).length > 0
                : dep_val in
                  variable.value.map((x) => {
                    return x.key
                  }))
            ) {
              var_.display = true
            } else if (
              cond === 'NOT_IN' &&
              (variable.value !== dep_val && variable.value.key
                ? Object.values(dep_val).filter(
                    (x) => x.trim() === variable.value.key.trim()
                  ).length === 0
                : !(
                    dep_val in
                    variable.value.map((x) => {
                      return x.key
                    })
                  ))
            ) {
              var_.display = true
            } else {
              var_.display = false
              this.renderTimestamp = Date.now()
            }
          } else {
            if (variable.type == 'boolean') {
              let TF = Object.values(var_.extra_config.depends_value).filter(
                (x) => Boolean(x) == variable.value
              )
              if (TF.length > 0) {
                var_.display = true
              } else {
                var_.display = false
              }
            } else {
              var_.display = false
            }
          }

          // this.setVariableInfoById(x, var_)
        })
      })
    },
    async findDataAutocomplete() {
      const _ = this
      let findPersonFields = {}
      //buscar variables base
      let filterDimensions = _.formData.dimensions
      let index = filterDimensions.filter((x) => x.id == 1)[0].base_variables
      //buscar indenfiticadores base
      index = index.filter((x) => [55, 54].indexOf(x.variable) != -1)
      //filtrar campos
      index.map((x) => {
        if (x.variable == 55 && x.value) {
          Object.assign(findPersonFields, { nid: x.value })
        } else if (x.value && x.value.value) {
          Object.assign(findPersonFields, { tid: x.value.key })
        }
      })

      this.autoCompleteInputDisable = false
      if ('nid' in findPersonFields && 'tid' in findPersonFields) {
        await this.getAutoCompleteData(findPersonFields).then((data) => {
          this.AutoCompleteForm(data.person)
        })
      }
    },
    AutoCompleteForm(data) {
      const _ = this
      const dimensions_temp = _.formData.dimensions
      this.formData.dimensions = []
      dimensions_temp.forEach((dim) => {
        dim.base_variables.filter((x) => {
          const datavar = data
            .filter((y) => y.variable === x.variable)
            .map((fy) => fy.data)
            .map((fyy) => fyy[0])
          if (datavar && datavar[0]) {
            if (x.type == 'list') {
              x.idk = x.id + Math.floor(Math.random() * 10) + 1
              x.value =
                datavar[0].json != null && datavar[0].json.length > 0
                  ? datavar[0].json
                  : datavar[0]
            } else {
              x.idk = x.id + (Math.floor(Math.random() * 10) + 1)
              x.value = datavar[0].value
            }
          }
        })
        dim.extended_variables.filter((x) => {
          const datavar = data
            .filter((y) => y.variable === x.variable)
            .map((fy) => fy.data)
            .map((fyy) => fyy[0])
          if (datavar && datavar[0]) {
            if (x.type == 'list') {
              x.idk = x.id + Math.floor(Math.random() * 10) + 1
              x.value =
                datavar[0].json != null && datavar[0].json.length > 0
                  ? datavar[0].json
                  : datavar[0]
            } else {
              x.idk = x.id + (Math.floor(Math.random() * 10) + 1)
              x.value = datavar[0].value
            }
          }
        })
      })
      this.$nextTick(() => {
        this.formData.dimensions = dimensions_temp
      })
    },
    infoCodHogar(family) {
      this.familiHome = family
    },
  },
  watch: {
    'formData.dimensions': {
      deep: true,
      handler(newValue, oldValue) {},
    },
  },
}
</script>

<style lang="scss">
#extra-config-modal .custom-select-md {
  height: calc(1.5em + 1rem + 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 0.95rem;
}
.with-separator {
  border-top: 1px solid #dee2e6 !important;
}
.dnd-drag.drag-out.drag-no-handle {
  .list-group-item {
    background-color: #f5fafd;
    color: gray;
    border: #e5eaee 1px solid;
  }
}

.tabs-forms .nav-link.disabled {
  color: gray !important;
}

.extended-vars,
.base-vars {
  .left-panel {
    margin-top: 1px;
  }
  .dimension-title {
    border-top: 1px solid rgb(238, 238, 238);
  }
  .btn.btn-block {
    .opened,
    .closed {
      float: right !important;
      margin-top: 4px;
      color: #226aa7;
      transition: transform 0.15s ease-in-out,
        background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
    }

    &.collapsed {
      .opened {
        display: none;
      }
      .closed {
        display: inline;
      }
    }
    &.not-collapsed {
      .opened {
        display: inline;
      }
      .closed {
        display: none;
      }
    }
  }
  .search {
    .form-control {
      height: 38px;
      padding-right: 0;
      padding-left: 20px;
      color: #000;
      background-color: rgba(255, 255, 255, 0.07);
      border: 1px solid rgba(0, 0, 0, 0.03);
      border-radius: 30px 0 0 30px;
      border-right: none;
      box-shadow: none;
    }
    .btn {
      color: #2185d0;
      background-color: rgba(255, 255, 255, 0.07);
      border-color: rgba(0, 0, 0, 0.03);
      border-radius: 0 30px 30px 0;
      box-shadow: none !important;
      border-left: none;
    }
  }
  .section-card {
    background-color: rgba(255, 255, 255, 0.6);
    border-radius: 10px;
  }
  .list2 {
    min-height: 140px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .card {
      border: 1px dashed #48c0f5;
      border-bottom: 3px solid #48c0f5;
      border-radius: 5px;

      .handle-cursor:hover {
        background-color: #48c1f51f;
      }

      &.dependent {
        border: 1px dashed #f7b84b;
        border-bottom: 3px solid #f7b84b;
        svg {
          color: #c79e51 !important;
        }
        .handle-cursor:hover {
          background-color: #ffbb4625;
        }
      }
      .handle-cursor {
        cursor: move;
      }
    }

    &.empty {
      text-align: center;
      // background-color: #f5fafd;
      padding: 10px;
    }
    &.empty::after {
      content: 'Arrastre y suelte la variable aquí';
      background-image: url('~~~@assets/images/add-form-img.png');
      background-position: center center;
      background-repeat: no-repeat;
      color: rgb(204, 204, 204);
      font-size: 14px;
      width: 100%;
      text-align: center;
      margin-top: 18px;
    }
    &.drop-allowed.empty::after {
      content: 'Suelte aquí para insertar la variable';
      background-image: none;
      font-size: 16px;
    }
    &.drop-forbidden {
      background-color: rgba(255, 0, 0, 0.12);
    }
    &.drop-allowed {
      background-color: rgba(61, 65, 255, 0.12);
    }
  }
  .section-name {
    .form-control {
      background-color: transparent !important;
      border: transparent !important;
      font-size: 18px;
    }
    .input-group-text {
      background-color: transparent !important;
      border: none;
    }
  }
}
</style>
